import { createReducer, on } from '@ngrx/store';
import * as OpportunityActions from './opportunity.actions';
import { OpportunityState } from './opportunity.state';

export const initialState: OpportunityState = {
  opportunity: null,
  loading: false,
  error: null,
};

export const opportunityReducer = createReducer(
  initialState,
  on(OpportunityActions.loadOpportunity, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(OpportunityActions.loadOpportunitySuccess, (state, { opportunity }) => ({
    ...state,
    opportunity,
    loading: false,
  })),
  on(OpportunityActions.loadOpportunityFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(OpportunityActions.updateOpportunityFieldSuccess, (state, { opportunity }) => ({
    ...state,
    opportunity,
    loading: false,
  })),
  on(OpportunityActions.updateOpportunityFieldFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Status transition reducers
  on(
    OpportunityActions.transitionToBacklog,
    OpportunityActions.transitionToActive,
    OpportunityActions.transitionToInReview,
    OpportunityActions.transitionToDeclined,
    OpportunityActions.transitionToComplete,
    OpportunityActions.transitionToCancelled,
    OpportunityActions.startProgress,
    OpportunityActions.requestFinalReview,
    OpportunityActions.requestFinancialReview,
    OpportunityActions.backToInProgress,
    OpportunityActions.cancelReview,
    OpportunityActions.markDone,
    OpportunityActions.routeForCompletion,
    (state) => ({
      ...state,
      loading: true,
      error: null,
    })
  ),

  on(
    OpportunityActions.transitionToBacklogSuccess,
    OpportunityActions.transitionToActiveSuccess,
    OpportunityActions.transitionToInReviewSuccess,
    OpportunityActions.transitionToDeclinedSuccess,
    OpportunityActions.transitionToCompleteSuccess,
    OpportunityActions.transitionToCancelledSuccess,
    OpportunityActions.startProgressSuccess,
    OpportunityActions.requestFinalReviewSuccess,
    OpportunityActions.requestFinancialReviewSuccess,
    OpportunityActions.backToInProgressSuccess,
    OpportunityActions.cancelReviewSuccess,
    OpportunityActions.markDoneSuccess,
    OpportunityActions.routeForCompletionSuccess,
    (state, { opportunity }) => ({
      ...state,
      opportunity,
      loading: false,
      error: null,
    })
  ),

  on(
    OpportunityActions.transitionToBacklogFailure,
    OpportunityActions.transitionToActiveFailure,
    OpportunityActions.transitionToInReviewFailure,
    OpportunityActions.transitionToDeclinedFailure,
    OpportunityActions.transitionToCompleteFailure,
    OpportunityActions.transitionToCancelledFailure,
    OpportunityActions.startProgressFailure,
    OpportunityActions.requestFinalReviewFailure,
    OpportunityActions.requestFinancialReviewFailure,
    OpportunityActions.backToInProgressFailure,
    OpportunityActions.cancelReviewFailure,
    OpportunityActions.markDoneFailure,
    OpportunityActions.routeForCompletionFailure,
    (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })
  ),

  // Workflow status update reducer
  on(OpportunityActions.updateOpportunityWorkflowStatus, (state, { workflowStatus }) => {
    if (state.opportunity && state.opportunity.id === workflowStatus.id) {
      return {
        ...state,
        opportunity: {
          ...state.opportunity,
          status: workflowStatus.status,
          workflowStage: workflowStatus.workflowStage,
          updatedAt: workflowStatus.updatedAt
        }
      };
    }
    return state;
  })
);
